import React from 'react'
import { Switch, useHistory } from 'react-router-dom'
import Download from '../component/Download'
import { PrivateRoute } from './privateRoute'
import { useGlobalState } from '../providers/GlobalState'
import ConfigPage from '../pages/Config/Config'
import { ConfigLayout } from '../component/Config/ConfigLayout'
import { Profile } from '../pages/Config/Profile'
import Procedures from '../pages/Config/Procedures'
import { Plans } from '../pages/Config/Plans'
import { Orders } from '../pages/Config/Orders'
import ProceduresSlug from '../component/Config/Procedures/ProcedureSlug'
import { useWorkspace } from '../providers/workspace'
import { WorkspaceSelector } from '../pages/WorkspaceSelector'

const ConfigRouter: React.FC = () => {
  const { loading } = useGlobalState()
  const {
    selectedWorkspace,
    setWorkspaceSelectorOpen,
    setRedirectTo
  } = useWorkspace(
    ({ selectedWorkspace, setWorkspaceSelectorOpen, setRedirectTo }) => ({
      selectedWorkspace,
      setWorkspaceSelectorOpen,
      setRedirectTo
    })
  )
  const history = useHistory()

  React.useEffect(() => {
    if (!selectedWorkspace) {
      setRedirectTo(history.location.pathname)

      setWorkspaceSelectorOpen(true)

      history.push('/configuracao')
    }
  }, [selectedWorkspace])

  // getting/downloading all data from API
  if (loading) {
    return <Download />
  }

  return (
    <ConfigLayout>
      <Switch>
        <PrivateRoute path="/configuracao" exact component={ConfigPage} />
        <PrivateRoute path="/configuracao/conta" exact component={Profile} />
        <PrivateRoute
          path="/configuracao/procedimentos"
          exact
          component={Procedures}
        />
        <PrivateRoute
          path="/configuracao/procedimentos/:id"
          exact
          component={ProceduresSlug}
        />
        <PrivateRoute path="/configuracao/planos" exact component={Plans} />
        <PrivateRoute path="/configuracao/pedidos" exact component={Orders} />
      </Switch>
      <WorkspaceSelector />
    </ConfigLayout>
  )
}

export default ConfigRouter
